import { useNavigate, useOutletContext } from 'react-router-dom';
import { ConfirmationStep, SignupError } from '../../components/signup';
import { SignupOutletContext } from '../../components/signup/types';
import { useFeatureFlags } from '../../hooks/useFeatureFlags';
import { useFlowType } from '../../hooks/useFlowType';
import { LoadingSpinner } from 'design-system/src/components/LoadingSpinner/LoadingSpinner';
import * as Sentry from '@sentry/react';
import { SignupType, canSetUpAccount } from '../../components/signup/utils';

const ConfirmationStepPage = () => {
  const navigate = useNavigate();
  const signupType = localStorage.getItem('signupType') || 'null';
  const { formState } = useOutletContext<SignupOutletContext>();
  const { data: featureFlags, isLoading: isLoadingFeatureFlags } = useFeatureFlags();
  const flowType = useFlowType();

  const handleNext = () => {
    // If user can set up account, redirect to verification email page
    if (canSetUpAccount(featureFlags, signupType as SignupType, formState.specialty)) {
      navigate('/signup/verification-email', { replace: true });
    } else {
      // If user cannot set up account, redirect to success page
      const basePath = `/${flowType}`;
      navigate(`${basePath}/success`);
    }
  };

  if (!signupType) {
    Sentry.captureException('[ConfirmationStepPage] No signup type found in local storage');
    return <SignupError />;
  }

  if (isLoadingFeatureFlags) {
    return <LoadingSpinner />;
  }

  return <ConfirmationStep onNext={handleNext} signupType={signupType as SignupType} />;
};

export default ConfirmationStepPage;
